<!-- eslint-disable -->
<template>
  <div 
    class="c3_org_sys_div" :style="C_indent"  
    :class="{c3_org_div: C_showCollapseButton == true || (searchQuery !== '' && !location.orgs)}"
  >
    <div :class="{G_hidden_element: C_showSelf === false}">
      <div 
        v-if="location.uid != null && location.isOrg == true"
        :class="{
          c3_org_entry: C_showSelf === true,
          G_hidden_element: C_showSelf === false}"
      > 
        <span 
          class="c2_childless_org_alignment_spacer" 
          v-if="!location.nodes || (C_hasOnlySystems)"
        ></span>
        <span 
            :class="{
              'c2_expand_collapse': (depth != 0 && 
              (C_showExpandButton == true || C_showCollapseButton == true ))}"
          >
            <span 
              class="fas fa-plus-square c2_fa_font"
              @click.stop="showChildren" 
              v-if="C_showExpandButton == true"
            ></span>
            <span 
              class="fas fa-minus-square c2_fa_font"
              @click.stop="hideChildren" 
              v-if="C_showCollapseButton == true"
            ></span>
        </span>
        <span 
          class="c2_org_icon_container" 
          :class="{
            'c2_org_icon_container_with_icon': 
            C_showExpandButton == true || C_showCollapseButton == true,
            'c2_org_icon_container_with_zero_depth': 
            depth == 0 && (C_showExpandButton == false && C_showCollapseButton == false),
            'c2_org_selected': location.isOrg && activeOrg === location.uid,
            'c2_not_selected': activeOrg !== location.uid}"
        >
          <span class="c2_org_icon" @click.stop="eventSelectOrg"> 
            {{ C_organizationName }}
          </span>
          <!-- <start> menu buttons for the org -->
          <span class="c2_org_buttons_container" v-if="activeOrg === location.uid">
            <span v-if="userPermissions.includes('a') || userPermissions.includes('t') || userPermissions.includes('u') || userPermissions.includes('v')">
              <button 
                v-for="group in C_filteredNotificationGroupsData"
                @click.stop="eventShowGroupDetail(group.uid)" 
                class="c2_org_buttons"
                style="margin-bottom: 5px;"
              >{{group.name}}</button>
            </span>
            
            <button 
              v-if="userPermissions.includes('a') || userPermissions.includes('t')"
              @click.stop="eventCreateNewGroup" 
              class="c2_org_buttons"
            > <b>+</b> Create Group</button>
            <span 
              class="c2_close_button_slider"
              @click.stop="passEventUnSelectItem"
            ></span>
          </span>
        </span>
      </div>
    </div>

    <div 
      :class="{ 
        c2_show_children: C_showChildrenFlag, 
        c2_hide_children: !this.C_showChildrenFlag && location.nodes}"
    >
      <c3-grouped-orgs-tree
        v-if="location.nodes && DV_actualLastOrgUid != null"
        :location="location.nodes"
        :depth="DV_childDepth + 1"
        :active-org="activeOrg"
        :search-query="searchQuery"
        :lastOrgUid="DV_actualLastOrgUid"
        :presetName="presetName"
        :expandCollapseCommand="DV_expandCollapseCommandToChild"
        :searchModeForceChildrenVisible="DV_SearchModeShowChildrenFlag"
        @pass-select-org="passSelectOrg"
        @pass-event-show-group-detail="passEventShowGroupDetail"
        @pass-event-create-new-group="passEventCreateNewGroup"
        @pass-event-unselect-selected-item="passEventUnSelectItem"
        @event-search-query-deep-match="passEventSearchQueryDeepMatch"
        @pass-event-search-query-group-match="passEventSearchQueryGroupMatch"
      ></c3-grouped-orgs-tree>
    </div>
    <div v-if="location.orgs">
      <c3-grouped-orgs-tree
        v-for="org in C_orderedOrganizations"
        :location="org"
        :key="org.key"
        :depth="DV_childDepth"
        :active-org="activeOrg"
        :search-query="searchQuery"
        :lastOrgUid="DV_actualLastOrgUid"
        :presetName="presetName"
        :expandCollapseCommand="DV_expandCollapseCommandToChild"
        :searchModeForceChildrenVisible="searchModeForceChildrenVisible"
        @pass-select-org="passSelectOrg"
        @pass-event-show-group-detail="passEventShowGroupDetail"
        @pass-event-create-new-group="passEventCreateNewGroup"
        @event-search-query-org-match="eventSearchQueryOrgMatch"
        @event-search-query-deep-match="passEventSearchQueryDeepMatch"
        @pass-event-unselect-selected-item="passEventUnSelectItem"
        @pass-event-search-query-group-match="passEventSearchQueryGroupMatch"
      ></c3-grouped-orgs-tree>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10OrgPermissions } from "../../../../watchdog_includes/base_i10_UI_mixins";
import _ from 'lodash';

export default {
  name: "c3GroupedOrgsTree",
  mixins: [bi10OrgPermissions],
  props: [
    'location', 
    'depth', 
    'activeOrg', 
    'searchQuery',
    'searchQueryRequestTimestamp',
    'lastOrgUid',
    'presetName',
    'expandCollapseCommand',
    'searchModeForceChildrenVisible'
  ],
  data() {
    return {
      DV_showChildrenFlag: this.depth < 1 ? true : false,
      DV_childDepth: this.depth,
      DV_actualLastOrgUid: null,
      DV_expandCollapseCommandToChild: null,
      DV_notificationGroupsData: [],
      DV_orgNotificationGroupJoins: {},
      DV_notificationGroupMetaData: {},
      DV_searchQueryMatchFlag: false,
      DV_searchQuerySubOrgMatchFlag: false,
      DV_searchQueryGroupMatchFlag: false,
      DV_searchQueryDeepMatchFlag: false,
      DV_SearchModeShowChildrenFlag: false
    }
  },
  mounted() {
    if (this.depth < 2) {
      this.startLocationListeners();
    }

    this.DV_orgNotificationGroupJoins = window.G_watchdog_data.IV_org_ngp_joins;
    this.DV_notificationGroupMetaData = window.G_watchdog_data.IV_ngp_meta_data;

    // TODO- We'll make this listener to start only for visible orgs.
    // once we make an other way to get group names for search functionality.
    this.startOrgGroupJoinListener()

    this.$nextTick(function() {
      this.DV_expandCollapseCommandToChild = this.expandCollapseCommand;
      if (this.location.uid && this.location.isSys) {
        this.DV_actualLastOrgUid = this.lastOrgUid;
      } else if (this.location.uid && this.location.isOrg) {
        this.DV_actualLastOrgUid = this.location.uid;
      } else if (this.lastOrgUid == null) {
        this.DV_actualLastOrgUid = "0";
      } else {
        this.DV_actualLastOrgUid = this.lastOrgUid;
      }

      if(this.location.isOrg == true) {
        this.bi10GetOrgPermissions(this.DV_actualLastOrgUid);
      }
    });
  },
  computed: {
    C_indent() {
      if (this.location.isOrg && this.location.nodes) {
        if (this.C_hasOnlySystems) {
          return "{}";
        }
        return { marginLeft: "2vw" };
      } else {
        return "{}";
      }
    },
    C_showChildrenFlag() {
      if (this.searchQuery !== '' && (this.DV_searchQueryMatchFlag === true ||
          this.DV_searchQuerySubOrgMatchFlag === true || 
          this.DV_searchQueryGroupMatchFlag === true || 
          this.DV_searchQueryDeepMatchFlag === true)
        ) {
        return true;
      }
      if (this.searchQuery !== '' && this.DV_SearchModeShowChildrenFlag === true) {
        return true;
      }
      if (this.DV_showChildrenFlag === true) {
        return true;
      }
      return false;
    },
    C_showCollapseButton() {
      if (this.location.nodes === null || this.location.nodes === undefined) {
        return false;
      }

      if (this.searchQuery !== '' && this.location.nodes != null &&
         this.DV_SearchModeShowChildrenFlag === true
       ) {
        return true;
      }

      // now check if org has sub orgs or only systems. 
      if (this.C_hasOnlySystems) {return false;}

      
      if (this.searchQuery === '' && this.DV_showChildrenFlag === true) {
        return true;
      }

      return false;
    },
    C_showExpandButton() {
      if (this.location.nodes == null || this.location.nodes == undefined) {
        return false;
      }

      if (this.searchQuery !== '' && this.location.nodes !== null &&
         this.DV_SearchModeShowChildrenFlag === false
       ) {
        return true;
      }

      // now check if org has sub orgs or only systems. 
      if (this.C_hasOnlySystems) {return false;}

      if (this.searchQuery === '' && this.DV_showChildrenFlag === false) {
        return true;
      }

      return false;
    },
    C_showSelf() {
      //top level orgs should always be visible unless a search query is running
      if (this.depth < 2 && this.searchQuery === '') {
        return true;
      }

      if(this.searchModeForceChildrenVisible === true) {
        return true;
      }

      if (this.searchQuery !== '' && 
      this.DV_searchQueryMatchFlag === false && this.DV_searchQuerySubOrgMatchFlag === false && 
      this.DV_searchQueryGroupMatchFlag === false && this.DV_searchQueryDeepMatchFlag === false) {
        return false;
      }

      return true
    },
    C_organizationName() {
      if(this.location.uid == null || this.location.uid == undefined || this.location.isOrg != true) {
        return "";
      }
      //if data isn't loaded yet show the database UID
      if(this.location.uid in this.C_orgMetaData == false) {
        return this.location.uid;
      }

      if(this.C_orgMetaData[this.location.uid] != null && 
        this.C_orgMetaData[this.location.uid] != undefined &&
        'name' in this.C_orgMetaData[this.location.uid] &&
        typeof(this.C_orgMetaData[this.location.uid]['name']) == 'string'
        ) {
          return this.C_orgMetaData[this.location.uid]['name'];
        } else {
          return this.location.uid;
        }
    },
    C_orgMetaData() {
      return window.vue_instance.$data.watchdog.orgMetaData;
    },
    C_hasOnlySystems() {
      if (this.location.nodes == null || this.location.nodes == undefined) {
        return false;
      }
      return !this.location.nodes.orgs && this.location.nodes.systems
    },
    C_orderedOrganizations() {
      // return ordered orgs
      for (var key in this.location.orgs) {
        var uid = this.location.orgs[key].uid;
        if (uid != null && uid != undefined && 
            uid in this.C_orgMetaData &&
            'name' in this.C_orgMetaData[uid] &&
            typeof(this.C_orgMetaData[uid]['name']) == 'string') {
          var tempName = this.C_orgMetaData[uid].name;
          this.location.orgs[key]['name'] = tempName;
        } else {
          this.location.orgs[key]['name'] = "";
        }
      }

      return _.orderBy(
        this.location.orgs,
        function(org) {
          return org.name.toLowerCase(); 
        }
      );
    },
    C_filteredNotificationGroupsData() {
      let filtered_data = [];

      if (this.searchQuery === false || this.searchQuery === null || 
          this.searchQuery === undefined || this.searchQuery === "") 
      {
        return this.DV_notificationGroupsData;
      }
      
      for (let index in this.DV_notificationGroupsData) {
        let entry = this.DV_notificationGroupsData[index];

        if (this.isSearchQueryMatched(entry.name, this.searchQuery) === true) {
          filtered_data.push(entry);
        }
      }

      return filtered_data;
    }
  },
  methods: {
    startLocationListeners() {
      this.startMetaDataListener()
    },
    startMetaDataListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (this.location.uid != null && this.location.uid != undefined &&
          window.vue_instance.$data.watchdog.watchdogDbConnected == true &&
          typeof this.location.uid == 'string') {
        if(this.location.isOrg === true) {

          // params for listener(org_uid, instant_remove_listener, component_id)
          window.G_watchdog_data.initOrgMetaDataListener(this.location.uid, false, "c2");
        }
      } else if(this.location.isOrg === true) {
        setTimeout(this.startMetaDataListener(), 200);
      }
    },
    startOrgGroupJoinListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (this.location.uid != null && this.location.uid != undefined &&
          window.vue_instance.$data.watchdog.watchdogDbConnected == true &&
          typeof this.location.uid == 'string') {
        if(this.location.isOrg === true) {
          window.G_watchdog_data.bi7InitOrgNotificationGroupJoinsListener(this.location.uid);
        }
      } else if(this.location.isOrg === true) {
        setTimeout(this.startOrgGroupJoinListener(), 200);
      }
    },
    hideChildren() {
      if (this.searchQuery !== '') { 
        this.DV_SearchModeShowChildrenFlag = false;  
        return; 
      }

      this.DV_showChildrenFlag = false;
    },
    showChildren() {
      if (this.searchQuery !== '') { 
        this.DV_SearchModeShowChildrenFlag = true;  
        return; 
      }

      this.DV_showChildrenFlag = true;
    },
    eventSelectOrg() {
      this.$emit("pass-select-org", this.location.uid);
    },
    eventShowGroupDetail(group_uid) {
      this.$emit('pass-event-show-group-detail', group_uid);
    },
    eventCreateNewGroup() {
      this.$emit('pass-event-create-new-group');
    },
    passSelectOrg(msg) {
      this.$emit("pass-select-org", msg);
    },
    passEventShowGroupDetail(msg) {
      this.$emit('pass-event-show-group-detail', msg);
    },
    passEventCreateNewGroup() {
      this.$emit('pass-event-create-new-group');
    },
    passEventUnSelectItem() {
      this.$emit("pass-event-unselect-selected-item")
    },
    eventSearchQueryOrgMatch(msg) {
      if (msg != this.searchQueryRequestTimestamp) { return;}      
      this.$emit("event-search-query-deep-match", msg);
      this.DV_searchQuerySubOrgMatchFlag = true;
    },
    eventSearchQueryGroupMatch(msg) {
      if (msg != this.searchQueryRequestTimestamp) { return;}
      this.$emit("pass-event-search-query-group-match", msg);
      this.DV_searchQueryGroupMatchFlag = true;
    },
    passEventSearchQueryGroupMatch(msg) {
      if (msg != this.searchQueryRequestTimestamp) { return;}      
      this.DV_searchQueryGroupMatchFlag = true;
      this.$emit("event-search-query-deep-match", msg);
    },
    passEventSearchQueryDeepMatch(msg) {
      if (msg != this.searchQueryRequestTimestamp) { return;}      
      this.$emit("event-search-query-deep-match", msg);      
      this.DV_searchQueryDeepMatchFlag = true;
    },
    updateNotificationGroupsData() {
      if (this.location.uid == null || this.location.uid == undefined ||
          typeof this.location.uid != 'string' || this.location.isOrg !== true) {
        return;
      }

      let notification_groups_data = [];
      let org_uid = this.location.uid;
      
      if (org_uid in this.DV_orgNotificationGroupJoins == false) {
        return;
      }

      for (let key in this.DV_orgNotificationGroupJoins[org_uid]) {
        let entry = {
          name: this.getNotificationGroupName(key),
          uid: key
        }
        notification_groups_data.push(entry);
      }

      this.DV_notificationGroupsData = _.orderBy(notification_groups_data, ['name']);
    },
    getNotificationGroupName(ngp_uid) {
      if (ngp_uid in this.DV_notificationGroupMetaData == true && 
          'name' in this.DV_notificationGroupMetaData[ngp_uid] == true) {
        return this.DV_notificationGroupMetaData[ngp_uid]['name'];
      } else {
        return `Loading.. ${ngp_uid}`;
      }
    },
    isSearchQueryMatched(name, query) {
      var ret = true;
      query = query.toLowerCase();
      name = name.toLowerCase();
      var query_parts = query.split(" ");

      for(var index in query_parts) {
        var word = query_parts[index];
        var matchedIndex = name.indexOf(word);
        if (matchedIndex == -1) {
          ret = false;
          break;
        }
      }
      return ret;
    },
  },
  watch: {
    expandCollapseCommand: {
      handler: function(val) {
        if (val == null || val.length < 1) {
          return;
        }

        if (val[0] == "E") {
          this.showChildren();
        } 
        if (val[0] == "C") {
          this.hideChildren();
        }
        
        this.DV_expandCollapseCommandToChild = this.expandCollapseCommand;
      }, deep: true
    },
    DV_orgNotificationGroupJoins: {
      handler: function() {
        this.updateNotificationGroupsData();
      },
      deep: true,
    },
    DV_notificationGroupMetaData: {
      handler: function() {
        this.updateNotificationGroupsData();
      },
      deep: true,
    },
    searchQuery() {
      if (this.searchQuery === '') {
        this.DV_searchQueryMatchFlag = false;
        this.DV_searchQuerySubOrgMatchFlag = false;
        this.DV_searchQueryGroupMatchFlag = false;
        this.DV_searchQueryDeepMatchFlag = false;
        this.DV_SearchModeShowChildrenFlag = false;
        return
      }

      //clearing the flags prevents previous results from still showing up so when a user goes from "de" to "demo" it clears results for "de"
      this.DV_SearchModeShowChildrenFlag = false;
      this.DV_searchQuerySubOrgMatchFlag = false;
      this.DV_searchQueryGroupMatchFlag = false;
      this.DV_searchQueryDeepMatchFlag = false;

      let matched_flag = false;

      if (this.location.uid && this.location.isOrg && this.DV_notificationGroupsData.length > 0) {
        var CI = this;
        var search_query_matched_flag = _.result(
          _.find(this.DV_notificationGroupsData, function(obj) {
              return CI.isSearchQueryMatched(obj.name, CI.searchQuery);
            }
          ), 'uid');
        
        if (search_query_matched_flag != null && search_query_matched_flag != undefined && search_query_matched_flag != "") {
           this.$emit('pass-event-search-query-group-match', this.searchQueryRequestTimestamp);
           this.eventSelectOrg();
           matched_flag = true;
          this.DV_searchQueryMatchFlag = true;
        } else {
          this.DV_searchQueryMatchFlag = false;
        }
      } 

      if (matched_flag != true && this.location.uid && this.location.isOrg && this.location.uid in this.C_orgMetaData) {
        var tempName = this.C_orgMetaData[this.location.uid].name;        
        if (tempName == undefined || tempName == null) {
          this.DV_searchQueryMatchFlag = false;
        } else if (this.isSearchQueryMatched(tempName, this.searchQuery) === true) {
          this.$emit('event-search-query-org-match', this.searchQueryRequestTimestamp);
          this.DV_searchQueryMatchFlag = true;
        } else {
          this.DV_searchQueryMatchFlag = false;
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m2/c3GroupedOrgsTree.vue